//Message validation forms Salesforce
document.addEventListener('DOMContentLoaded', () => {
    const formulaire = document.getElementById('SFform');
    formulaire.addEventListener('submit', (e) => {
        e.preventDefault(); // Empêcher l'envoi immédiat du formulaire

        let isValid = formulaire.checkValidity();
        let messageValidation = document.getElementById('messageValidation');
        
        if (isValid) {
            messageValidation.textContent = 'Merci pour l\'intérêt que vous portez à Lily-Rose Promotion. Nous revenons vers vous sous 24h. A très vite. L\'équipe de Lily-Rose Promotion.';
            messageValidation.className = 'validation';
            formulaire.style.display = 'none';

            setTimeout(() => {
                formulaire.submit(); // Envoi du formulaire après un court délai
            }, 2000); // Délai de 2 secondes
        } else {
            messageValidation.textContent = 'Il y a eu un problème et le formulaire n\'a pas été envoyé.';
            messageValidation.className = 'validation';
        }
    });
});